<template>
	<div class="projects-page-row">
		<div v-for="sector in sectors" v-if="!show_menu">
			<h1 v-if="sector.id === sector_id" style="margin-left: 30px;">{{ sector[`title_${currentLanguage}`] || sector[`title_en`] }}</h1>
		</div>
		<div class="col-1 sidebar sidebar-filter" v-if="show_menu">
			<div style="display: inline-block; margin-bottom: 10px">
				<el-input
					type="text"
					:placeholder="`${ translate('Search') }`"
					v-model="searchTerm"	
					@keyup.enter="getProjects"		
					style="width: 70%; display: inline-block; margin-bottom: 0"
				/>
				<button class="search-btn ion-search" @click="getProjects"></button>
			</div>
            <div class="filter-widget">
            	<div class="filter-services">
	                <div class="filter-title">
						{{ translate('Services') }}
					</div>
	                <ul class="filters">
	                    <li v-for="service in services" :key="service.id">
		                    <button v-if="service.status" :class="{ active: service.id === service_id }" @click="toggleFilter(service.id, 'service_id')" style="font-family: 'Nunito Sans', sans-serif;">
		                    	{{ service[`title_${currentLanguage}`] || service[`title_en`] }}
		                    </button>
	                    </li>
	                </ul>
            	</div>
            	<div class="filter-sectors">
					<div class="filter-title">{{ translate('Sectors') }}</div>
	                <ul class="filters">
	                    <li v-for="sector in sectors" :key="sector.id">
		                    <button :class="{ active: sector.id === sector_id }" @click="toggleFilter(sector.id, 'sector_id')" style="font-family: 'Nunito Sans', sans-serif;">
		                    	{{ sector[`title_${currentLanguage}`] || sector[`title_en`] }}
		                    </button>
	                    </li>
	                </ul>
            	</div>
				<div class="filter-concept">
	                <p >{{ translate('Concepts') }}</p>
					<el-switch type="checkbox" checked v-model="conceptsOnly" @change="toggleConcepts" style="display: inline-block; margin-bottom: 4px;"/>
	            </div>
            	<div class="filter-mobile">
	                <select v-model="service_id" style="margin-bottom: 10px;" @change="toggleFilter(undefined, 'service_id')">
	                	<option value="">{{translate('Filter by service')}}</option>
	                	<option v-for="service in services.filter(s => s.status)" :key="service.id" :value="service.id">
							{{ service[`title_${currentLanguage}`] || service[`title_en`] }}
		                </option>
	                </select>
	                <select v-model="sector_id" style="margin-bottom: 10px;" @change="toggleFilter(undefined, 'sector_id')">
	                	<option value="">{{translate('Filter by sector')}}</option>
	                	<option v-for="sector in sectors" :key="sector.id" :value="sector.id">
		                	{{ sector[`title_${currentLanguage}`] || sector[`title_en`] }}
		                </option>
	                </select>
            	</div>
            </div>
		</div>
		<div :class="show_menu ? 'col-3' : 'col-4'">
			<div id="projects-list" :class="'projects ' + view" v-show="view !== 'map'">
			    <div class="table-header">
			        <span class="title">{{ translate('Title') }}</span>
			        <span class="location">{{ translate('Location') }}</span>
			        <span class="size">{{ translate('Size') }}</span>
			        <span class="date">{{ translate('Date') }}</span>
			    </div>
		    	<project-card :key="project.id" v-for="project in projects" :project="project" />
			</div>
			<div id="map" v-if="view === 'map'"></div>
			<ul class="pagination" v-if="params.last_page > 1">
			    <li v-if="params.current_page > 1">
			    	<button @click="goToPage(params.current_page - 1)"><i class="ion-arrow-left-c"></i></button>
			    </li>
			    <li :class="'loaded'" v-for="number in params.last_page" :key="number">
				    <button @click="goToPage(number)" :class="activePage(number)">{{ number }}</button>
			    </li>
			    <li v-if="params.current_page < params.last_page">
			    	<button @click="goToPage(params.current_page + 1)"><i class="ion-arrow-right-c"></i></button>
			    </li>
			</ul>
		</div>
	</div>
</template>
<script>

	import ProjectCard from './ProjectCard.vue';
	import axios from 'axios';


	export default {
		components: {
			ProjectCard
		},
		beforeMount() {

			if(this.$route.query.sector_id) this.sector_id = this.$route.query.sector_id;
			if(this.$route.query.service_id) this.service_id = this.$route.query.service_id;
			if (this.$route.query.searchTerm) this.searchTerm = this.$route.query.searchTerm;
			if(this.$route.query.show_menu) this.show_menu = (this.$route.query.show_menu == 'true');

		},
		mounted() {
			axios.get(`/pa/services`)
				.then(resp => {
					this.services = resp.data.data;
				});
			axios.get(`/pa/sectors`)
				.then(resp => {
					this.sectors = resp.data.data;
				});
			this.getProjects();

		},
		watch: {
			service_id: 'updateRoute',
			sector_id: 'updateRoute',
			searchTerm: 'updateRoute'
		},
		computed: {
			currentLanguage() {
				var lang = window.location.pathname.split('/')[1];
				switch(lang) {
					case 'hu':
						return lang;
						break;
					case 'en':
						return lang;
						break;
					case 'fr':
						return lang;
						break;
					case 'ru':
						return lang;
						break;
					case 'ar':
						return lang;
						break;
					case 'de':
						return lang;
						break;
					default: 
						return 'en';
				}
			}
		},
		methods: {
            goToPage(pagenumber) {
                if(pagenumber < 1) return;
                if(pagenumber > this.params.last_page) return;
                this.params.page = pagenumber;
            	this.getProjects();
            	this.scrollToTop();
            },

            scrollToTop() {
        	    var timeout = setTimeout(() => {
	            	window.scrollTo({
						left: 0,
						top: 0,
						behavior: "instant",
					});
        	    }, 5);
            },

            activePage(pagenumber) {
                return this.params.current_page == pagenumber ? 'active'  : '';
            },

            toggleConcepts() {
				this.getProjects();
            },

            toggleFilter(id, type) {
				this.params.current_page = 1;
				this.params.page = 1;

				if (id === undefined) {
					if (type === 'sector_id') this.service_id = '';
					if (type === 'service_id') this.sector_id = '';
				} else if (this[type] === id) {
					this[type] = '';
				} else {
					this[type] = id;
				}

				this.getProjects();
			},

			updateRoute() {
				// Update URL with new query params
				this.$router.push({
					query: {
						...this.$route.query,
						sector_id: this.sector_id || undefined,
						service_id: this.service_id || undefined,
						show_menu: this.show_menu,
						searchTerm: this.searchTerm
					}
				});
			},

			getProjects() {

				if(this.service_id || this.sector_id || this.conceptsOnly || this.searchTerm.length > 0)  {
					var params = {		
                        page: this.params.page,
						lang: this.currentLanguage
					};
                    if(this.conceptsOnly) params["concepts-only"] = this.conceptsOnly;
                    if(this.service_id) params.service_id = this.service_id;
                    if(this.sector_id) params.sector_id = this.sector_id;
					if(this.searchTerm.length > 0) params['search-term'] = this.searchTerm;
	                axios
	                    .get('/pa/filtered-projects', {
	                        params: params
	                    })
	                    .then((resp, model) => {
							this.projects = resp.data.data;
							this.params.current_page = resp.data.current_page;
							this.params.last_page = resp.data.last_page;
							this.params.total = resp.data.total;
	                    });
				} else {
					axios.get(`/pa/projects`, { params: this.params })
						.then(resp => {
							this.projects = resp.data.data;
							this.params.current_page = resp.data.current_page;
							this.params.last_page = resp.data.last_page;
							this.params.total = resp.data.total;
						});
				}
            },
            translate(word) {
            	const found = this.words.find(w => w.en === word);
				return found && found[this.currentLanguage] ? (
					found[this.currentLanguage]) : this.translate('Translation not found')
            },
		},
		data() {
			return {
				conceptsOnly: false,
				view: 'grid',
				services: [],
				sectors: [],
				service_id: '',
				sector_id: '',
				show_menu: true,
				searchTerm: '',
				params: {
					status: '1',
					current_page: 1,
					last_page: 1,
					per_page: 12,
					with: 'clients',
					total: 0,
					page: 1
				},
				projects: [],
				project: {},
			words: [
				{
					en: 'Services',
					hu: 'Szolgáltatásaink',
					de: 'Was wir anbieten'
				},
				{
					en: 'Sectors',
					hu: 'Szektoraink',
					de: 'Sektoren'
				},
				{
					en: 'Grid',
					hu: 'Rács',
					de: 'Gitter'
				},
				{
					en: 'List',
					hu: 'Lista',
					de: 'Liste'
				},
				{
					en: 'Map',
					hu: 'térkép',
					de: 'Karte'
				},
				{
					en: 'Title',
					hu: 'Név',
					de: 'Titel'
				},
				{
					en: 'Location',
					hu: 'Hely',
					de: 'Ort'
				},
				{
					en: 'Size',
					hu: 'Méret',
					de: 'Größe'
				},
				{
					en: 'Date',
					hu: 'Dátum',
					de: 'Datum'
				},
				{
					en: 'Filter by service',
					hu: 'Szűrés szolgáltatásra',
					de: 'Nach Dienstleistung filtern'
				},
				{
					en: 'Filter by sector',
					hu: 'Szűrés szektorra',
					de: 'Nach Sektor filtern'
				},
				{
					en: 'Translation not found',
					hu: 'Fordítás nem található',
					de: 'Übersetzung nicht gefunden'
				},
				{
					en: 'Search',
					hu: 'Keresés',
					de: 'Suche nach'
				},
				{
					en: 'Concepts',
					hu: 'Koncepció tervek',
					de: 'Konzeptionen'
				}
			]
		}
	}
}

</script>

<style lang="scss">

    @import "./../../sass/mixins";
    @import "./../../sass/variables";

	.filter-title {
		font-size: 19px;
		margin-bottom: 18px;
		font-family: 'Nunito Sans', sans-serif;
		font-weight: bold;
		
	}

	  input[type=text] {
  		border: none;
 		 margin-bottom: 0px;
  		padding:0px;
  		height:30px;
  	}

	.projects {
		$gutter: 15px;

	    flex-wrap: wrap;
		display: flex;
		margin: 0;

		@media screen and (max-width: $mobile-max) {
			flex-direction: column;
		}

		@media screen and (max-width: $desktop-max) {
			margin: 0 -15px;
		}

		.table-header {
			display: none;
		}

		.project {
			padding: 0 $gutter 30px;
			width: 280px;
			display: block;
			height: 260px;

			@media screen and (max-width: $tablet-max) {
				height: 220px;
				width: 240px;
				padding: 0 0px 30px 30px;
			}

			@media screen and (max-width: $mobile-max) {
				width: 100%;
				padding: 0 $gutter 30px;
			}

			a {
				text-decoration: none;
				position: relative;
				display: block;
				height: 100%;

				&:after {
					$start-gradient-color: rgba(51, 198, 244, 1); // $blue; 51, 198, 244
					$end-gradient-color: rgba(51, 198, 244, 0); //$light-blue; 38, 70, 116
					background-image: linear-gradient(0deg, $start-gradient-color 15%, $end-gradient-color 30%);
					background-color: transparent;
					background-size: cover;
					transition: all 300ms;
					position: absolute;
					display: block;
					opacity: 0.8;
					height: 100%;
					content: '';
					width: 100%;
					z-index: 9;
					left: 0;
					top: 0;
		
				}

				h3, span {
					transition: all 300ms;
					opacity: 1;
				}

				&:hover {

					h3, span {
						transition: all 300ms;
						opacity: 0;
					}
					&:after {
						transition: all 300ms;
						opacity: 0;
					}
				}
			}

				.title {
					font-family: 'Nunito Sans', sans-serif;
					position: absolute;
					margin: 10px;
					bottom: 0;
    				color: white;
    				text-shadow: 1px 1px 4px #244472;
					z-index: 10;
				}

				.size,
				.client,
				.location,
				.date {
					display: none;

				}

				.image {
					background-position: top center;
					background-size: cover;
					position: relative;
					height: 100%;
					z-index: 8;
					// padding: 20px;
				}

				.image img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
		}

		&.list {
			border: 1px solid lighten(#000, 90%);
			margin-bottom: 20px;
			border-radius: 4px;

			.table-header {
				flex-direction: row;
				display: flex;
				padding: 15px;
				width: 100%;

				> .title {
					padding: 0;
					flex: 3;
				}

				> span {
					font-weight: bold;
					padding: 0 15px;
					flex: 1;

					&.size,
					&.date {
						text-align: right;
					}
					&.client {
						flex: 2;
					}
				}

				@media screen and (max-width: $mobile-max) {
					display: none;
				}
			}

			.project {
				border-top: 1px solid lighten(#000, 90%);
				height: inherit;
				float: initial;
				width: 100%;
				padding: 0;
				margin: 0;

				a {
					background-image: none !important;
					text-decoration: none;
					flex-direction: row;
					padding: 15px;
					display: flex;
					color: $black;
					
					@media screen and (max-width: $mobile-max) {
						flex-direction: column;
					}

					&:after {
						display: none;
					}

					&:hover {
						background-color: lighten(#000, 97%);

						h3, span {
							transition: all 300ms;
							opacity: 1;
						}
					}

					.mobile-label {
						text-transform: uppercase;
						font-weight: bold;
						font-size: 80%;
						display: none;
						width: 65px;

						@media screen and (max-width: $mobile-max) {
							display: inline-block;
						}
					}

					> span {
						padding: 0 15px;

						@media screen and (max-width: $mobile-max) {
							text-align: left !important;
							padding: 0;
						}
					}
				}

					.title {
						position: relative;
						bottom: initial;
						color: $black;
						left: initial;
						flex: 3;
						
					}

					.size {
						text-align: right;
						display: block;
						flex: 1;
					}
					.client {
						display: block;
						flex: 2;
					}
					.location {
						display: block;
						flex: 1;
					}
					.date {
						text-align: right;
						display: block;
						flex: 1;
					}

					.image {
						display: none;
					}
			}
		}
	}

	.sidebar {	
		@media screen and (max-width: $tablet-max) {
			.filters {
				font-size: 0.7rem;
			}
		}

		@media screen and (max-width: $mobile-max) {
			.filters {
				display: none;
			}
		}
		padding-right: 1.25rem;
	}

	.projects-page-row {
		display: block;

		&:after {
			content: '';
			display: table;
			clear: both;
		}

		.col-1 {
			float: left;
			width: 25%;

			@media screen and (max-width: $mobile-max) {
				width: 100%;
			}
		}

		.col-3 {
			float: left;
			width: 75%;

			@media screen and (max-width: $mobile-max) {
				width: 100%;
			}
		}

		.col-4 {
			float: left;
			width: 100%;

			@media screen and (max-width: $mobile-max) {
				width: 100%;
			}
		}

		@media screen and (max-width: $desktop-max) {
			flex-direction: column;
		}
	}

	.filter-widget {
		margin-bottom: 30px;

		@media screen and (max-width: $desktop-max) {
			margin-bottom: 20px;
			display: block;
			width: 100%;
		}

		.filter-services {
			margin-bottom: 45px;

			@media screen and (max-width: $desktop-max) {
			}
			@media screen and (max-width: $mobile-max) {
				display: none;
			}
		}

		.filter-sectors {
			margin-bottom: 35px;

			@media screen and (max-width: $desktop-max) {
			}
			@media screen and (max-width: $mobile-max) {
				display: none;
			}
		}

		.filter-mobile {
			display: none;
			@media screen and (max-width: $mobile-max) {
				display: block;
			}
		}

		select {
			display: none;
			width: 100%;
			
			@media screen and (max-width: $desktop-max) {
				border: 1px solid lighten(#000, 90%);
				background-color: lighten(#000, 97%);
				display: block;
				padding: 5px;
			}
		}

		button {
			background-color: transparent;
			padding: 5px 5px 5px 25px;
			text-decoration: none;
			transition: all 300ms;
			position: relative;
			text-align: left;
			cursor: pointer;
			display: block;
			color: $black;
			border: none;
			width: 100%;

			&:before {
				background-color: lighten(#000, 95%);
				border: 1px solid lighten(#000, 80%);
				border-radius: 50%;
				position: absolute;
				height: 15px;
				content: '';
				width: 15px;
				top: 9px;
				left: 0;
			}

			&.active {

				&:before {
					background-color: $blue;
					border: 1px solid $blue;
				}

				&:hover {

					&:before {
						background-color: rgba($blue, 0.7);
					}
				}
			}

			&:hover {

				&:before {
					background-color: lighten(#000, 80%);
				}
			}

			&:focus {
				outline: none;
			}
		}

		.title {
			text-transform: uppercase;
			text-overflow: ellipsis;
			margin-bottom: 5px;
			overflow: hidden;
			font-size: 18px;
		}

		.filters {
			width: 100%;
			padding-left: 15px;

			label {
				cursor: pointer;
				padding: 0;
				margin: 0;
				
			}

				span {
					display: block;
					padding: 10px;

					&:before {
						color: lighten(#000, 50%);
						content: '\f372';
						width: 20px;

						@include ionicon();
					}
				}

				input {
					position: absolute;
					display: block;
					left: -9999px;
					
					&:checked + span {

						&:before {
							content: '\f373';
							color: $green;

						}
					}
				}
			li.active {
				span {

					&:before {
						content: '\f373';
						color: $green;

					}
				}
			}
		}

		&.view {

			.filters {
				flex-direction: row;
				display: flex;
				padding: 0;
				margin: 0;

				li {
					padding: 0;
					margin: 0;
					flex: 1;

					&:first-child {
						button {
							border-radius: 10px 0 0 10px;
						}
					}
					&:last-child {
						button {
							border-radius: 0 10px 10px 0;
						}
					}

					button {
						background-color: lighten(#000, 95%);
						text-align: center;
						padding: 10px;
						width: 100%;

						@media screen and (max-width: $desktop-max) {
							padding: 5px;
						}

						&:hover {
							background-color: rgba($blue, 0.1);
						}

						&:before {
							display: none;
						}

						&.active {
							background-color: $blue;
							color: #fff;

							&:hover {
								background-color: rgba($blue, 0.8);
							}
						}
					}

						span {
							padding: 20px 10px;
							height: 100%;
							width: 100%;

							&:hover {
								background-color: lighten(#000, 95%);
							}

							&:before {
								display: none;
							}
						}

						input {

							&:checked + span {
								background-color: $blue;
								cursor: default;
								color: #fff;

								&:hover {
									background-color: rgba($blue, 0.7);
								}
							}
						}
				}
			}
		}
	}
	.search-btn {
		display: inline-block;
		height: 38px;
		width: 38px;
		margin-left: 5px;
		border-radius: 50%;
		border: none;
	}

	.ion-search {
		font-size: 20px;
	}

	.filter-concept {
		p {
			display: inline-block;
			font-size: 17px;
			padding-right: 5px;
		}

		.ion-checkmark-circled { color: $green; }
		.ion-ios-circle-outline { color: $black; }

		label {
			font-weight: 400;
			cursor: pointer;
		}
		@media screen and (max-width: $tablet-max) {	
			label {
				font-size: 0.9rem;
			}
		}
	}

</style>
